import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type UserAddFormType = {
  userId?: string;
  email?: string;
  userName?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  typeOfCompany?: string;
  wtaSubType?: string;
  tpaSubType?: string;
  jobTitle?: string;
  phoneNumber?: string;
  userType?: string;
  registrationDate?: Date;
  expiryDate?: Date;
  expireDayCount?: number | string;
  paidFeatureSubscriptionType?: string;
};

export const UserAddFormSchema = Model({
  email: Types.StringType().isRequired("Email is required"),
  userName: Types.StringType().isRequired("UserName is required"),
  firstName: Types.StringType().isRequired("First name is required"),
  lastName: Types.StringType().isRequired("Last name is required"),
  companyName: Types.StringType(),
  typeOfCompany: Types.StringType(),
  wtaSubType: Types.StringType().isRequired(
    "WTA subscription type is required"
  ),
  tpaSubType: Types.StringType().isRequired(
    "TPA subscription type is required"
  ),
  jobTitle: Types.StringType(),
  phoneNumber: Types.StringType(),
  userType: Types.StringType(),
  registrationDate: Types.DateType(),
  expireDate: Types.DateType(),
  expireDayCount: Types.NumberType(),
});

export const UserAddDefaultValues: UserAddFormType = {
  userId: "",
  email: "",
  userName: "",
  firstName: "",
  lastName: "",
  companyName: "",
  typeOfCompany: "",
  wtaSubType: "",
  tpaSubType: "",
  jobTitle: "",
  phoneNumber: "",
  userType: "",
  registrationDate: new Date(),
  expiryDate: new Date(),
  expireDayCount: 0,
};
